import './functions/scrollToHash';
import '../../blocks/cookie/cookie';
import '../../blocks/header/header';
import '../../blocks/banner/banner';
import '../../blocks/banner-slider/banner-slider';
import '../../blocks/locations/locations';
import '../../blocks/text-video/text-video';
import '../../blocks/questions/questions';
import '../../blocks/services-acc/services-acc';
import '../../blocks/text-image-acc/text-image-acc';
import '../../blocks/addresses/addresses';
import '../../blocks/modal-content/modal-content';
import '../../blocks/locations-list/locations-list';
import '../../blocks/google-reviews/google-reviews';
import '../../blocks/offer-slider/offer-slider';
